import { FC } from 'react';
import { StyleSheet } from 'react-native';
import { Appbar } from 'react-native-paper';
import { TopBarProps } from './types';

export const BottomBar: FC<Omit<TopBarProps, 'title'>> = (
  props: Omit<TopBarProps, 'title'>
) => {
  return (
    <Appbar.Header
      statusBarHeight={0}
      mode="center-aligned"
      style={[
        props.style
          ? [props.style, styles.footerContainer]
          : styles.footerContainer,
        !props.hideBottomBorder && styles.bottomBorder,
      ]}
    >
      {props.left}
      {props.additionalHeaderBlock}
      {props.right}
    </Appbar.Header>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    position: 'absolute',
    bottom: 15,
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlignVertical: 'center',
    width: '100%',
    columnGap: 16,
  },
  bottomBorder: {
    elevation: 3,
  },
});
